
import RowWrap from '@/components/detail/row_wrap/index.vue'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { CommonService } from '@/services'
import { ElInput } from 'element-ui/types/input'
import { cloneDeep, isEqual } from 'lodash'

const maxLength = 5
const appKeywordMaxLength = 7

export interface Keyword {
    temp: string
    keyword: string
    edit: boolean
}

let copyWord: any = {}

@Component({
    name: 'hot-word',
    components: {
        RowWrap
    }
})
export default class extends Vue {
    private appHotWord: Keyword[] = []
    private pcHotWord: Keyword[] = []
    private appInputVisible = false
    private pcInputVisible = false
    private inputValue = ''
    private isLoading = false

    @Ref('keywordInputEl') private keywordInput!: ElInput[]
    @Ref('savePCTagInput') private savePcTagInputEl!: ElInput
    @Ref('saveAppTagInput') private saveAppTagInputEl!: ElInput

    private mounted() {
        this.getHotWord()
    }

    /** 获取热搜 */
    private async getHotWord() {
        this.isLoading = true
        const result = await CommonService.getHotWord({})
        this.isLoading = false
        if (result.status === 200) {
            this.appHotWord = this.formatKeyword(result.data.app_keywords)
            this.pcHotWord = this.formatKeyword(result.data.pc_keywords)
            copyWord = cloneDeep(result.data)
        }
    }

    /** 更新热搜 */
    private async updateHotWord() {
        const pcHotWord = this.pcHotWord.map(item => item.keyword)
        const appHotWord = this.appHotWord.map(item => item.keyword)
        const isAppChange = !isEqual(copyWord.app_keywords, appHotWord)
        const isPcChange = !isEqual(copyWord.pc_keywords, pcHotWord)
        if (!isAppChange && !isPcChange) {
            return this.$message({
                message: '请先做出修改',
                showClose: true,
                type: 'warning'
            })
        }
        const params = {
            pc_keywords: pcHotWord,
            app_keywords: appHotWord
        }
        this.isLoading = true
        const result = await CommonService.updateHotWord(params)
        this.isLoading = false
        if (result.status === 200) {
            return this.$message({
                type: 'success',
                message: '更新成功',
                showClose: true
            })
        }
        this.$message({
            type: 'error',
            message: result.message || '发生错误，更新失败',
            showClose: true
        })
    }

    private formatKeyword(keywods: string[]): Keyword[] {
        return keywods.map(keyword => {
            return {
                temp: '',
                edit: false,
                keyword 
            }
        })
    }

    private handleClose(word: Keyword, type: 'pc' | 'app') {
        let hotWord = type === 'pc' ? this.pcHotWord : this.appHotWord
        hotWord.splice(hotWord.indexOf(word), 1)
    }

    private showInput(type: 'pc' | 'app') {
        let el:ElInput
        let keywords = type === 'pc' ? this.pcHotWord : this.appHotWord
        let visiable = type === 'app' ? 'appInputVisible' : 'pcInputVisible'
        if (keywords.length >= maxLength) {
            return this.$message({
                type: 'warning',
                message: `目前最多只能设置${maxLength}个热搜关键字`,
                showClose: true
            })
        }
        Reflect.set(this, visiable, true)
        this.$nextTick(()=> {
            el = type === 'pc' ? this.savePcTagInputEl : this.saveAppTagInputEl
            el.focus()
        })
    }

    private handleInputConfirm(type: 'app' | 'pc') {
        const isApp = type === 'app'
        // app 端限制字符数量
        if (isApp && this.inputValue.length > appKeywordMaxLength) {
            this.$message({
                type: 'warning',
                message: `APP 端不能超过${appKeywordMaxLength}个字符`,
                showClose: true
            })
            return
        }
        let visiable = isApp ? 'appInputVisible' : 'pcInputVisible'
        let key = isApp ? 'appHotWord' : 'pcHotWord'
        let keywords = Reflect.get(this, key)
        if (this.inputValue) {
            keywords.push({
                temp: '',
                edit: false,
                keyword: this.inputValue
            })
        }
        Reflect.set(this, visiable, false)
        this.inputValue = ''
    }

    private onEditTag(keyword: Keyword, type: 'pc' | 'app') {
        let key = type === 'app' ? 'appHotWord' : 'pcHotWord'
        let keywords = Reflect.get(this, key)
        keywords.forEach((item: any) => item.edit = false)
        keyword.temp = keyword.keyword
        keyword.edit = true
        this.$nextTick(() => {
            this.keywordInput[0].focus()
        })
    }

    private onKeywordInputBlur(keyword: Keyword) {
        keyword.temp = ''
        keyword.edit = false
    }

    private onKeywordInputEnter(keyword: Keyword) {
        keyword.keyword = keyword.temp
        keyword.temp = ''
        keyword.edit = false
    }
}
